import {formatDateTimeWithSeconds} from "@/utils/dateUtils.ts";
import {TableColumn} from "@fs/uikit-react";

export const getNoteTableColumns = (): TableColumn[] => {
  return [
    {
      key: 'title',
      title: 'Заголовок',
      width: 'calc(100% - 400px)',
    },
    {
      key: 'modifiedAt',
      title: 'Змінено',
      width: '200px',
      sortable: true,
      render: (text: string) => formatDateTimeWithSeconds(text),
    },
    {
      key: 'createdAt',
      title: 'Створено',
      width: '200px',
      sortable: true,
      render: (text: string) => formatDateTimeWithSeconds(text),
    }
  ];
}
